/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_AdminDashboardGrantList } from '../models/PagedResultDto_AdminDashboardGrantList';
import type { PagedResultDto_RsuAwardListDto } from '../models/PagedResultDto_RsuAwardListDto';
import type { PagedResultDto_UpcomingVestingGrantsDto } from '../models/PagedResultDto_UpcomingVestingGrantsDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_RsuAwardImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_RsuAwardImportResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants';
import type { Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetails } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetails';
import type { Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO';
import type { Wealthlane_AwardService_Dtos_RSUAward_ExportRSUAwardForUpdateRequestDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_ExportRSUAwardForUpdateRequestDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetGrantDetailsDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetGrantDetailsDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobRequestDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobRequestDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RsuAwardCreationResponseDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RsuAwardCreationResponseDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardImportDataDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardImportDataDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RsuAwardImportTemplateParseDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RsuAwardImportTemplateParseDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RsuAwardNumberDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RsuAwardNumberDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RsuAwardSettlementHistory } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RsuAwardSettlementHistory';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingScheduleDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingScheduleDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUDocumentDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUDocumentDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_VestingDatesSettlementTypeRequestDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_VestingDatesSettlementTypeRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RsuAwardService {

    /**
     * @param sessionId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardStopBulkImport(
sessionId: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/stop-bulk-import/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_BulkImport_RsuAwardImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardValidateBulkRSu(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_RsuAwardImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/validate-bulk-rSU',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardGrants(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/grants',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardPlanTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/plan-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardVestingSchedule(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/vesting-schedule',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RsuAwardCreationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardRSUAwards(
requestBody?: Array<Wealthlane_AwardService_Dtos_RSUAward_RsuAwardImportTemplateParseDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_RsuAwardCreationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/r-sUAwards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RsuAwardCreationResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppRSUAwardRSUAwardsInBulk(
requestBody?: Array<Wealthlane_AwardService_Dtos_RSUAward_RsuAwardImportTemplateParseDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_RsuAwardCreationResponseDto>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/r-sUAward/r-sUAwards-in-bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RsuAwardCreationResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppRSUAwardRSUAward(
requestBody?: Array<Wealthlane_AwardService_Dtos_RSUAward_RsuAwardImportTemplateParseDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_RsuAwardCreationResponseDto>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/r-sUAward/r-sUAward',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardImportDataDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardForUpdateById(
awardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardImportDataDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-for-update-by-id/{awardId}',
            path: {
                'awardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param approvalStatusIds 
     * @param fromDate 
     * @param toDate 
     * @param employeeStatuses 
     * @param rsuStatus 
     * @param rsuAcceptance 
     * @param createdFromDate 
     * @param createdToDate 
     * @param grantFromDate 
     * @param grantToDate 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_RsuAwardListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardList(
approvalStatusIds?: Array<number>,
fromDate?: string,
toDate?: string,
employeeStatuses?: Array<number>,
rsuStatus?: number,
rsuAcceptance?: number,
createdFromDate?: string,
createdToDate?: string,
grantFromDate?: string,
grantToDate?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_RsuAwardListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-list',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'FromDate': fromDate,
                'ToDate': toDate,
                'EmployeeStatuses': employeeStatuses,
                'RSUStatus': rsuStatus,
                'RSUAcceptance': rsuAcceptance,
                'CreatedFromDate': createdFromDate,
                'CreatedToDate': createdToDate,
                'GrantFromDate': grantFromDate,
                'GrantToDate': grantToDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardGetExportRSuAward(
requestBody?: Wealthlane_AwardService_Dtos_RSUAward_ExportRSUAwardForUpdateRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/get-export-rSUAward',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromDate 
     * @param toDate 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUFileNameList(
fromDate?: string,
toDate?: string,
): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUFile-name-list',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardDownloadRSuAwardSample(): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/download-rSUAward-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardEmployeeStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/employee-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUStatuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAcceptances(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAcceptances',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardEmployeeIds(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/employee-ids',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetGrantDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardGrantDetails(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetGrantDetailsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/grant-details',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardOverview(
rsuAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-overview/{RSUAwardId}',
            path: {
                'RSUAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingScheduleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardVestingSchedule(
rsuAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-vesting-schedule/{RSUAwardId}',
            path: {
                'RSUAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUDocumentDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardDocuments(
rsuAwardId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_RSUDocumentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-documents/{RSUAwardId}',
            path: {
                'RSUAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardDownloadDocument(
requestBody?: Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/download-document',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardStatusById(
rsuAwardId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-status-by-id/{RSUAwardId}',
            path: {
                'RSUAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardExportRSuAwardVestingSchedule(
rsuAwardId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/export-rSUAward-vesting-schedule/{RSUAwardId}',
            path: {
                'RSUAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardSendParticipantsSignUpLinks(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/send-participants-sign-up-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RsuAwardSettlementHistory OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardSettlementHistory(
rsuAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RsuAwardSettlementHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-settlement-history/{RSUAwardId}',
            path: {
                'RSUAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RsuAwardNumberDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardNumbers(
rsuAwardId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_RsuAwardNumberDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-numbers/{RSUAwardId}',
            path: {
                'RSUAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_UpcomingVestingGrantsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardUpcomingVestingGrants(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_UpcomingVestingGrantsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/upcoming-vesting-grants',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingDate 
     * @param grantId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardAdminDashboardGrantView(
vestingDate?: string,
grantId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/admin-dashboard-grant-view',
            query: {
                'VestingDate': vestingDate,
                'GrantId': grantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardAwardedParticipants(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/awarded-participants',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardUpcomingGrantList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/upcoming-grant-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingDate 
     * @param grantId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_AdminDashboardGrantList OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardAdminDashboardGrantList(
vestingDate?: string,
grantId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_AdminDashboardGrantList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/admin-dashboard-grant-list',
            query: {
                'VestingDate': vestingDate,
                'GrantId': grantId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppRSUAwardRsuAwardById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/r-sUAward/rsu-award-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardCancelRsuAwardById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/cancel-rsu-award-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardExportAdminDashboardGrantList(
requestBody?: Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/export-admin-dashboard-grant-list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param grantId 
     * @param input 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetails OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardTransactionForTax(
grantId: string,
input?: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetails>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/transaction-for-tax/{GrantId}',
            path: {
                'GrantId': grantId,
            },
            query: {
                'input': input,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardTransactionDetailByTransactionId(
transactionId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_AwardTransactionDetailsByTransactionIdDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/transaction-detail-by-transaction-id/{TransactionId}',
            path: {
                'TransactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRsuBulkImportStatus(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/rsu-bulk-import-status/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardDetailByRSuVestingDateId(
rsuVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-detail-by-rSUVesting-date-id/{RSUVestingDateId}',
            path: {
                'RSUVestingDateId': rsuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUAwardDetailByRSuVestingDateIdForParticipant(
rsuVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUAward-detail-by-rSUVesting-date-id-for-participant/{RSUVestingDateId}',
            path: {
                'RSUVestingDateId': rsuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardPublishRsuAward(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/publish-rsu-award',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppRSUAwardRsuAward(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/r-sUAward/{id}/rsu-award',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardIds 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppRSUAwardRsuAwardLists(
awardIds?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/r-sUAward/rsu-award-lists',
            query: {
                'AwardIds': awardIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuVestingDateId 
     * @param settlementTypeId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardSetRSuVestingDateSettlementType(
rsuVestingDateId?: string,
settlementTypeId?: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/set-rSUVesting-date-settlement-type',
            query: {
                'rsuVestingDateId': rsuVestingDateId,
                'settlementTypeId': settlementTypeId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuVestingDateId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardRSUVestingDateSettlementType(
rsuVestingDateId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward/r-sUVesting-date-settlement-type/{rsuVestingDateId}',
            path: {
                'rsuVestingDateId': rsuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuVestingDateId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardClearRSuVestingDateSettlementType(
rsuVestingDateId: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/clear-rSUVesting-date-settlement-type/{rsuVestingDateId}',
            path: {
                'rsuVestingDateId': rsuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRSUAwardSetMultipleRSuVestingDateSettlementType(
requestBody?: Array<Wealthlane_AwardService_Dtos_RSUAward_VestingDatesSettlementTypeRequestDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/r-sUAward/set-multiple-rSUVesting-date-settlement-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
